import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { useIsModal } from "@/components/General/Modal/context/modal.context";
import { useStorePickerContext } from "@/components/Store/StorePicker/storePicker.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export const NoResults = () => {
    const { t } = useGranite();

    const isModal = useIsModal();

    const { clear } = useStorePickerContext();

    return (
        <section
            className={cn(
                "tw:w-full tw:flex tw:flex-col tw:items-center tw:justify-center",
                {
                    "tw:min-h-[40dvh]": !isModal
                }
            )}
        >
            <p className={cn("tw:font-bold tw:text-xl tw:mb-1")}>
                {t("form.storePicker.nothingFound")}
            </p>
            <Button
                type={"button"}
                color={"link"}
                onClick={clear}
                className={cn("tw:p-0 tw:underline")}
            >
                {t("form.storePicker.nothingFound.reset")}
            </Button>
        </section>
    );
};
